<div class="flex items-center gap-2 flex-wrap p-1 bg-grey/30 ps-2 pe-3 border rounded-3xl border-gray-100 ">
  <ng-container *ngIf="inputClass==='primary'">
    <div *ngIf="!!filterTitle" class="font-semibold flex items-center gap-1">
      <span class="border rounded-full border-gray-200 px-1 pt-1 me-1 "><mat-icon class="scale-75" color="primary">filter_alt</mat-icon></span>
      <span class="text-gray-500">{{ filterTitle }}:</span>
    </div>
    <div class="flex gap-1 flex-wrap">
      <ng-container *ngFor="let btn of filters; let i = index">
        <button (click)="toggleSelection(btn)"
                class="px-3 py-2 text-[.85rem] flex items-center gap-1 {{btn?.selected ? 'border border-solid border-primary bg-primary/5' : 'bg-white'}} border text-primary rounded-2xl font-semibold text-nowrap transition-all"
                matRipple>
          {{ btn?.key }}
        </button>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="inputClass==='green'">
    <div *ngIf="!!filterTitle" class="font-semibold flex items-center gap-1">
      <span class="border rounded-full border-gray-200 px-1 pt-1 me-1 "><mat-icon class="scale-75 text-green-400">filter_alt</mat-icon></span>
      <span class="text-gray-500">{{ filterTitle }}:</span>
    </div>
    <div class="flex gap-1 flex-wrap">
      <ng-container *ngFor="let btn of filters; let i = index">
        <button (click)="toggleSelection(btn)"
                class="px-3 py-2 text-[.85rem] flex items-center gap-1 {{btn?.selected ? 'border border-green-300 bg-green-50' : 'bg-white'}} border text-green-400 rounded-2xl font-semibold text-nowrap transition-all"
                matRipple>
          {{ btn?.key }}
        </button>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="inputClass==='secondary'">
    <div *ngIf="!!filterTitle" class="font-semibold flex items-center gap-1">
      <span class="border rounded-full border-gray-200 px-1 pt-1 me-1 "><mat-icon class="scale-75 text-secondary-500">filter_alt</mat-icon></span>
      <span class="text-gray-500">{{ filterTitle }}:</span>
    </div>
    <div class="flex gap-1 flex-wrap">
      <ng-container *ngFor="let btn of filters; let i = index">
        <button (click)="toggleSelection(btn)"
                class="px-3 py-2 text-[.85rem] flex items-center gap-1 {{btn?.selected ? 'border border-solid border-secondary-300 bg-secondary-50/50' : 'bg-white'}} border text-secondary-500 rounded-2xl font-semibold text-nowrap transition-all"
                matRipple>
          {{ btn?.key }}
        </button>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="inputClass==='accent'">
    <div *ngIf="!!filterTitle" class="font-semibold flex items-center gap-1">
      <span class="border rounded-full border-gray-200 px-1 pt-1 me-1 "><mat-icon class="scale-75 text-accent-400">filter_alt</mat-icon></span>
      <span class="text-gray-500">{{ filterTitle }}:</span>
    </div>
    <div class="flex gap-1 flex-wrap">
      <ng-container *ngFor="let btn of filters; let i = index">
        <button (click)="toggleSelection(btn)"
                class="px-3 py-2 text-[.85rem] flex items-center gap-1 {{btn?.selected ? 'bg-accent !text-white' : 'bg-white'}} border text-accent-400 rounded-2xl font-semibold text-nowrap transition-all"
                matRipple>
          {{ btn?.key }}
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
